var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonNotebookReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 26.875V29.5625H10.1937L2.6875 37.0687L4.58756 38.9688L12.0938 31.4626V36.2812H14.7812V26.875H5.375ZM25.5312 13.4375H34.9375V16.125H25.5312V13.4375ZM25.5312 20.1562H34.9375V22.8438H25.5312V20.1562ZM25.5312 26.875H34.9375V29.5625H25.5312V26.875Z",
    fill: "#0FA958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 6.71875H5.375C4.66245 6.71946 3.97929 7.00284 3.47544 7.50669C2.97159 8.01054 2.68821 8.6937 2.6875 9.40625V22.8438H5.375V9.40625H20.1562V36.2812H37.625C38.3376 36.2805 39.0207 35.9972 39.5246 35.4933C40.0284 34.9895 40.3118 34.3063 40.3125 33.5938V9.40625C40.3118 8.6937 40.0284 8.01054 39.5246 7.50669C39.0207 7.00284 38.3376 6.71946 37.625 6.71875ZM22.8438 33.5938V9.40625H37.625L37.6277 33.5938H22.8438Z",
    fill: "#0FA958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNotebookReference);
export default __webpack_public_path__ + "static/media/carbon_notebook-reference.76d1650a3fdc6d352b0ff2694b182d03.svg";
export { ForwardRef as ReactComponent };